import * as types from "../../constants/types";

export const getPic = () => {
  return {
    type: types.GET_PIC_BEGIN,
  };
};
